import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const DEFAULT_FAQS = [
    {
        question: "How do I get started with ConRa?",
        answer: "Getting started is simple: 1) Download the ConRa app from the App Store or Google Play, 2) create an account and sign in, 3) Create your first project. No credit card is required for the trial period.",
    },
    {
        question: "What are the key features of ConRa?",
        answer: "ConRa offers project management, team collaboration, reporting, and automation tools.",
    },
    {
        question: "How much does ConRa cost?",
        answer: "ConRa offers a variety of pricing plans, including a free trial and paid subscriptions based on your team's needs.",
    },
    {
        question: "What kind of support do you offer?",
        answer: "We offer 24/7 customer support via email, live chat, and phone.",
    },
];

const FAQ = ({ faqs = DEFAULT_FAQS }) => {
    const navigate = useNavigate();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [openIndex, setOpenIndex] = useState(null);

    const handleNavigation = (section) => {
        if (section === "contact") {
            navigate("/contact-us");
        } else {
            document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section id="faq">
            <div className="faq-container">
                <h2 className="h1-48-800">Your Questions, <span>Answered</span></h2>
                <p className="faq-description">
                    We've compiled a list of the most frequently asked questions about ConRa to help you get the information you need.
                </p>

                <div className="faq-qa-border">
                    {/* ── Desktop two-column layout ── */}
                    <div className="faq-desktop">
                        <div className="faq-desktop-questions">
                            {faqs.map((faq, index) => (
                                <button
                                    key={index}
                                    className={`faq-desktop-q ${selectedIndex === index ? "faq-desktop-q--active" : ""}`}
                                    onClick={() => setSelectedIndex(index)}
                                >
                                    {faq.question}
                                </button>
                            ))}
                        </div>
                        <div className="faq-desktop-answer">
                            <p>{faqs[selectedIndex].answer}</p>
                        </div>
                    </div>

                    {/* ── Mobile accordion layout ── */}
                    <div className="faq-mobile">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${openIndex === index ? "open" : ""}`}
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                            >
                                <div className="faq-question">
                                    {faq.question}
                                    <span className="">{openIndex === index ? "−" : "+"}</span>
                                </div>
                                {openIndex === index && <div className="faq-answer">{faq.answer}</div>}
                            </div>
                        ))}
                    </div>
                </div>{/* end faq-qa-border */}

                <div className="faq-footer">
                    <p>Still have questions? We're here to help!</p>
                    <button className="faq-button" onClick={() => handleNavigation("contact")}>Contact Support</button>
                </div>
            </div>
        </section>
    );
};

export default FAQ;
